"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = getConfig;

function getGlobalWKLink(env) {
  if (!window.WKLink || !window.WKLink.getApi) {
    return {};
  }

  var envToApi = {
    dbg: function dbg() {
      return window.WKLink.getApi(window.window.location.hostname, 'dev');
    },
    // 生产环境的配置，不要随意变更。
    production: function production() {
      return window.WKLink.getApi(window.location.hostname, 'prod');
    }
  };

  if (!envToApi[env]) {
    return {};
  }

  return envToApi[env]() || {};
}

var prodWKLink = getGlobalWKLink('production');
var devWKLink = getGlobalWKLink('dbg');
/**
 * 生产环境#接口请求配置
 */

var prodConfig = {
  BASE_URL: prodWKLink.main || 'https://apiv1.lizhiweike.com',
  GATEWAY_URL: prodWKLink.gateway || 'https://gateway-weike.lizhiweike.com',
  API_GW: prodWKLink.apiGw || 'https://api-gw.lizhiweike.com'
};
/**
 * 测试环境#接口请求配置
 */

var devConfig = {
  BASE_URL: devWKLink.main || "https://main-weike.dev6.weike.fm",
  GATEWAY_URL: devWKLink.gateway || "https://gateway.test.weike.fm",
  API_GW: devWKLink.apiGw || "https://api.test.weike.fm"
};
/**
 * 根据环境获取接口请求配置
 * env: dbg | development | production
 * @param env
 */

function getConfig(env) {
  if (env === 'development' || env === 'dbg') {
    return devConfig;
  }

  return prodConfig;
}


//////////////////
// WEBPACK FOOTER
// ./~/@weike/services/lib/services/paths.js
// module id = 629
// module chunks = 4